<div class="app-boot-error" role="alert" aria-live="assertive">
  <div class="app-boot-error-panel">
    <img
      class="app-boot-error-lockup"
      [attr.src]="canvasLockupUrl()"
      [alt]="brandName"
      width="208"
      height="43"
    />

    <h2 class="app-boot-error-title">The app didn't finish loading.</h2>

    <p class="app-boot-error-message">
      Signing out and back in usually fixes this. If you're sure your connection is OK, you can just
      refresh the page instead.
    </p>

    <div class="app-boot-error-actions">
      <button
        type="button"
        class="app-boot-error-button app-boot-error-button-primary"
        [disabled]="resetting()"
        (click)="onResetAndReload()"
      >
        {{ resetting() ? 'Signing out…' : 'Sign out and reload' }}
      </button>
      <button
        type="button"
        class="app-boot-error-button app-boot-error-button-secondary"
        [disabled]="resetting()"
        (click)="onReload()"
      >
        Refresh
      </button>
      <button
        type="button"
        class="app-boot-error-link"
        [disabled]="resetting()"
        (click)="onKeepWaiting()"
      >
        Keep waiting
      </button>
    </div>

    @if (stuckSignals().length > 0) {
      <details class="app-boot-error-diagnostic">
        <summary>Show details</summary>
        <ul>
          @for (sig of stuckSignals(); track sig) {
            <li>
              <code>{{ sig }}</code>
            </li>
          }
        </ul>
        <p class="app-boot-error-diagnostic-hint">
          Send this to support if signing out doesn't help.
        </p>
      </details>
    }
  </div>
</div>
